import { Box, Stack, Typography } from '@mui/material';

import { CASE_AI_DESCRIPTIONS, CASE_AI_STATUS_COLORS } from '@/pages/Cases';

import useStyles from './CaseTableTooltipHeader.styles';

const CaseTableTooltipHeader = () => {
  const { classes } = useStyles();

  return (
    <Box className={classes.tooltipContainer}>
      <Stack direction="column" spacing={1}>
        <Typography className={classes.tooltipLabel}>
          Explanation of AI Statuses
        </Typography>
        {CASE_AI_DESCRIPTIONS.map((caseDescription) => (
          <Box key={caseDescription.label}>
            <Typography
              color={
                CASE_AI_STATUS_COLORS[
                  caseDescription.label as keyof typeof CASE_AI_STATUS_COLORS
                ]
              }
              className={classes.tooltipLabel}
            >
              {caseDescription.label}
            </Typography>
            :{' '}
            <Typography className={classes.tooltipDescription}>
              {caseDescription.description}
            </Typography>
          </Box>
        ))}
      </Stack>
    </Box>
  );
};

export default CaseTableTooltipHeader;
